var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomethingWentWrongIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 263.668,
    height: 198.862,
    viewBox: "0 0 263.668 198.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58427",
    "data-name": "Group 58427",
    transform: "translate(-551.166 -226.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page_under_construction",
    transform: "translate(551.166 226.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M263.752,15.585H.67A18.688,18.688,0,0,1,2.782,9.679,18.913,18.913,0,0,1,19.276,0h225.87a18.905,18.905,0,0,1,16.49,9.679A18.7,18.7,0,0,1,263.752,15.585Z",
    transform: "translate(-0.377)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M281.217,204.386H158.236a2.7,2.7,0,0,1,0-5.246H281.217a2.7,2.7,0,0,1,0,5.246Z",
    transform: "translate(-89.737 -66.157)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M263.375,15.585a18.7,18.7,0,0,0-2.116-5.906A18.905,18.905,0,0,0,244.769,0H18.9A18.913,18.913,0,0,0,2.4,9.679,18.874,18.874,0,0,0,0,18.9V179.964a18.918,18.918,0,0,0,18.9,18.9h225.87a18.907,18.907,0,0,0,18.9-18.9V18.9A18.837,18.837,0,0,0,263.375,15.585Zm-.581,164.379a18.03,18.03,0,0,1-15.567,17.858,18.212,18.212,0,0,1-2.457.166L22.4,197.051c.782-.848-19.109,3.566-20.855-17.088L.874,18.9a18,18,0,0,1,.306-3.314A17.822,17.822,0,0,1,3.41,9.679,18.013,18.013,0,0,1,18.9.874h225.87a18.013,18.013,0,0,1,15.489,8.8,18,18,0,0,1,2.536,9.22Z",
    transform: "translate(0)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M253.912,296.4H224.335a3.277,3.277,0,0,1-3.274-3.274v-2.958a3.277,3.277,0,0,1,3.274-3.273h29.577a3.277,3.277,0,0,1,3.274,3.273v2.958A3.277,3.277,0,0,1,253.912,296.4Z",
    transform: "translate(-129.339 -129.476)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M513.912,75.274H484.335A3.277,3.277,0,0,1,481.061,72V69.042a3.277,3.277,0,0,1,3.274-3.273h29.577a3.277,3.277,0,0,1,3.274,3.273V72A3.277,3.277,0,0,1,513.912,75.274Z",
    transform: "translate(-270.758 -37.017)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M354,296.34H324.421a3.5,3.5,0,0,1-3.492-3.492V289.89a3.5,3.5,0,0,1,3.492-3.492H354a3.5,3.5,0,0,1,3.492,3.492v2.958A3.5,3.5,0,0,1,354,296.34Zm-29.577-9.068a2.621,2.621,0,0,0-2.618,2.617v2.958a2.621,2.621,0,0,0,2.618,2.618H354a2.621,2.621,0,0,0,2.618-2.618V289.89A2.621,2.621,0,0,0,354,287.272Z",
    transform: "translate(-185.548 -129.195)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M275.815,173.386H120.184a2.623,2.623,0,1,1,0-5.246H275.815a2.623,2.623,0,0,1,0,5.246Z",
    transform: "translate(-68.135 -48.709)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M72.185,75.886H52.513a2.623,2.623,0,0,1,0-5.246H72.185a2.623,2.623,0,1,1,0,5.246Z",
    transform: "translate(-28.08 -39.759)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M341.185,75.886H321.513a2.623,2.623,0,1,1,0-5.246h19.672a2.623,2.623,0,0,1,0,5.246Z",
    transform: "translate(-179.482 -39.759)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M426.185,75.886H406.513a2.623,2.623,0,0,1,0-5.246h19.672a2.623,2.623,0,0,1,0,5.246Z",
    transform: "translate(-227.323 -39.759)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M288,17.312H193.9a1.586,1.586,0,1,1,0-3.172H288a1.586,1.586,0,1,1,0,3.172Z",
    transform: "translate(-108.238 -7.958)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58428",
    "data-name": "Group 58428",
    transform: "translate(-3.787 3.213)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1217",
    "data-name": "Ellipse 1217",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    transform: "translate(667.787 280.925)",
    fill: "#de8d8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155697",
    "data-name": "Path 155697",
    d: "M3.683-10.182,3.5.316H1.5l-.187-10.5ZM2.5,4.691A1.4,1.4,0,0,1,1.481,4.27a1.357,1.357,0,0,1-.417-1.018,1.348,1.348,0,0,1,.417-1.011A1.4,1.4,0,0,1,2.5,1.82a1.382,1.382,0,0,1,1.007.421,1.4,1.4,0,0,1,.432,1.011,1.423,1.423,0,0,1-.205.723,1.509,1.509,0,0,1-.522.522A1.359,1.359,0,0,1,2.5,4.691Z",
    transform: "translate(685.4 302.72)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrongIcon);
export default __webpack_public_path__ + "static/media/something_went_wrong_icon.11c2aead389e86f568b04289dd0d011e.svg";
export { ForwardRef as ReactComponent };